import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "py-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "max-w-7xl 2xl:max-w-screen-2xl mx-auto" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-bold text-white" }, "Welcome to your loan dashboard!")
  ])
], -1)
const _hoisted_2 = { class: "grid grid-cols-8 gap-4" }
const _hoisted_3 = { class: "w-16 h-16 bg-sky text-white flex items-center justify-center rounded-md hidden md:flex flex-shrink-0" }
const _hoisted_4 = { class: "md:pl-5" }
const _hoisted_5 = { class: "text-xs md:text-sm leading-4 md:leading-5 font-medium mb-1 text-gray-500" }
const _hoisted_6 = { class: "text-xl md:text-2xl leading-8 font-semibold" }
const _hoisted_7 = { class: "grid grid-cols-9 gap-4 mt-4 relative" }
const _hoisted_8 = {
  key: 1,
  class: "col-span-9 bg-white px-4 md:px-6 py-6 rounded-lg shadow-sm flex justify-between items-center"
}
const _hoisted_9 = { class: "max-w-3xl" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-medium" }, "You don't have any matches yet, but no worries, they're coming!", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "In the interim, click here to update your profile and make sure you get the best matches for you!", -1)
const _hoisted_12 = { class: "mt-6" }
const _hoisted_13 = { class: "bg-blue-100 w-32 h-32 rounded-lg items-center justify-center flex-shrink-0 ml-5 hidden md:flex" }
const _hoisted_14 = { class: "col-span-9 lg:col-span-6" }
const _hoisted_15 = { class: "bg-white shadow-sm rounded-lg divide-y" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "px-4 md:px-6 py-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-xl md:text-2xl md:leading-8 font-bold" }, "Loan requests")
], -1)
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "text-xs max-w-xl mt-1" }
const _hoisted_19 = { class: "w-5 h-5 rounded-full bg-gray-300 text-gray-700 text-xs ml-2 flex items-center justify-center flex-shrink-0" }
const _hoisted_20 = { class: "md:w-2/3" }
const _hoisted_21 = { class: "text-sm leading-5 font-medium text-sky mb-1 md:mb-2" }
const _hoisted_22 = { class: "text-xs md:text-sm leading-5 font-normal text-gray-500 flex items-start md:items-center" }
const _hoisted_23 = { class: "md:w-1/3 flex md:flex-col md:items-end justify-between md:justify-start pt-3 md:pt-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "mx-1" }, "|", -1)
const _hoisted_25 = { class: "inline-flex items-center leading-5 font-medium text-sky text-xs mt-1" }
const _hoisted_26 = { class: "col-span-9 lg:col-span-3 hidden lg:block" }
const _hoisted_27 = { class: "bg-white shadow-sm rounded-lg" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-4" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl leading-8 font-bold" }, "Notifications")
], -1)
const _hoisted_29 = { class: "flow-root pl-6 pr-8 pt-4 pb-8" }
const _hoisted_30 = {
  role: "list",
  class: "-mb-8"
}
const _hoisted_31 = { class: "relative pb-8" }
const _hoisted_32 = {
  key: 0,
  class: "absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200",
  "aria-hidden": "true"
}
const _hoisted_33 = { class: "relative flex space-x-3" }
const _hoisted_34 = { class: "h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center ring-8 ring-white" }
const _hoisted_35 = { class: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" }
const _hoisted_36 = { class: "text-sm text-gray-500" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-gray-700" }, "You", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AnnotationIcon = _resolveComponent("AnnotationIcon")!
  const _component_LocationMarkerIcon = _resolveComponent("LocationMarkerIcon")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_TicketIcon = _resolveComponent("TicketIcon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, ({ title, subtitle, icon }, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "bg-white rounded-lg col-span-4 lg:col-span-2 shadow-sm flex items-center p-4 md:p-6",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(icon), { class: "w-6 h-6" }))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h4", _hoisted_5, _toDisplayString(title), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(subtitle), 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_base_spinner, {
            key: 0,
            class: "bg-white rounded-lg shadow-sm col-span-9 h-80"
          }))
        : (!_ctx.distributions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_router_link, {
                    to: "/account",
                    class: "inline-block bg-sky text-white px-3 py-2.5 rounded-md"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Update profile")
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_AnnotationIcon, { class: "text-sky w-8 h-8" })
              ])
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedDistributions, (distributions, key) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["bg-gray-100 text-gray-600 py-2 px-4 md:px-6 flex items-center justify-between", { 'cursor-pointer': key == 'declined' }]),
                        onClick: ($event: any) => (_ctx.onSectionClick(key))
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", null, _toDisplayString(_ctx.labelsMap[key].title), 1),
                          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.labelsMap[key].subtitle), 1)
                        ]),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(distributions.length), 1)
                      ], 10, _hoisted_17),
                      (key !== 'declined' || key == 'declined' && _ctx.showArchive)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(distributions, ({ distributionDashboardOfferingMemorandum, status, createdDate, shareCode, id }, index) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              class: "py-4 px-4 md:px-6 block md:flex justify-between items-center",
                              key: index,
                              to: `/offering-memorandum/${distributionDashboardOfferingMemorandum.id}/distribution/${id}/share-code/${shareCode}`
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("h5", _hoisted_21, _toDisplayString(distributionDashboardOfferingMemorandum.headline), 1),
                                  _createElementVNode("p", _hoisted_22, [
                                    _createVNode(_component_LocationMarkerIcon, { class: "w-3 h-3 md:w-4 md:h-4 mr-1 mt-1 md:mt-0 flex-shrink-0" }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.getAddress(distributionDashboardOfferingMemorandum.address)), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["py-1 px-3 flex justify-center items-center text-xs rounded-full", {
                      'bg-yellow-200 text-yellow-700': status == 'Quoted',
                      'bg-yellow-100 text-yellow-700': status == 'InformationRequested',
                      'bg-gray-100 text-gray-700': status == 'Viewed' || _ctx.statusMap[status] == 'Received',
                      'bg-red-100 text-red-700': status == 'NotInterested',
                      'bg-green-100 text-green-700': status == false
                    }])
                                  }, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getDate(createdDate)), 1),
                                    _hoisted_24,
                                    _createElementVNode("span", null, _toDisplayString(_ctx.statusMap[status]), 1)
                                  ], 2),
                                  _createElementVNode("span", _hoisted_25, [
                                    _createTextVNode(" Open details "),
                                    _createVNode(_component_ArrowRightIcon, { class: "w-4 h-3 ml-1" })
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("ul", _hoisted_30, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, ({ date, name, route }, index) => {
                        return (_openBlock(), _createElementBlock("li", { key: index }, [
                          _createElementVNode("div", _hoisted_31, [
                            (index < _ctx.notifications.length - 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_33, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_34, [
                                  _createVNode(_component_TicketIcon, { class: "w-5 h-5 text-gray-500" })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_36, [
                                    _hoisted_37,
                                    _createTextVNode(" received a "),
                                    _createVNode(_component_router_link, {
                                      to: route,
                                      class: "text-sky font-medium"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]),
                                    _createTextVNode(" " + _toDisplayString(date), 1)
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ], 64))
    ])
  ], 64))
}